export default __webpack_public_path__ + "static/ScreenCrowStudiosLogoText-39129f302fffad3f3201d7f46d68df77.png";